import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import {CampaignListAPI, deleteCampaigndataAPI} from "./../../../API/Admin/CampaignAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import PopupDelete from "./../../PopupDelete";
import Paginate from "./../../../utils/Pagination";

const Campaign = () =>{

    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [delheading, setDelHeading] = useState("");
    const [delmessage, setDelMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [deletecampaignid, setDeleteCampaignId] = useState("");
    const [iscampaigndelete, setIsCampaignDelete] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 15;


    useEffect(() => {

        CampaignListAPI(setCampaigns, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [iscampaigndelete, currentPage]);

    const showDeletePopup = (deluserid) =>{
    
        setDelHeading("Delete this user?");

        setDelMessage("Are you sure you want to delete this user?");

        setShowModal(true);

        //console.log('>>>>>>' + deluserid);

        setDeleteCampaignId(deluserid);
    }

    const hideDeletePopup = () =>{

        setDelHeading("");

        setDelMessage("");

        setShowModal(false);

        setDeleteCampaignId("");
    }

    const handleDeleteCampaign = (event) =>{
        event.preventDefault();

        //console.log('Delete button click');

        deleteCampaigndataAPI(deletecampaignid, setLoading, setShowModal, setIsCampaignDelete);
        
    }

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }



    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Campaigns</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="">
                                        <Link to="/admin/campaign/add" className="btn btn-primary">
                                            <i className="ti ti-square-rounded-plus me-2"></i>Add Campaign
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">

                            <div className="card-body">

                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <div className="dropdown">
                                        
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        
                                    </div>
                                </div>

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                												
                                                <th style={{ width: '15%' }}>Created On</th>
                                                <th style={{ width: '25%' }}>Name</th>
                                                <th style={{ width: '5%' }}>Link</th>
                                                <th style={{ width: '10%' }}>Source</th>
                                                <th style={{ width: '10%' }}>Account</th>
                                                <th style={{ width: '10%' }}>Status</th>
                                                <th style={{ width: '25%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="7">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (campaigns && campaigns.length > 0  ? 
                                                ( campaigns.map(campaign => 
                                                    (
                                            
                                                        <tr key={campaign.id}>
                                                            <td>{moment(campaign.created_at).format('DD-MM-YYYY h:mm:ss')}</td>
                                                            <td>{campaign.name}</td>
                                                            <td>
                                                                <Link to={campaign.promo_link} target="_blank">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-window-maximize">
                                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                                        <path d="M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z" />
                                                                        <path d="M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6" />
                                                                        <path d="M12 8h4v4" />
                                                                        <path d="M16 8l-5 5" />
                                                                    </svg>
                                                                </Link>
                                                            </td>
                                                            <td>{campaign.source == 1 ?
                                                                    <p>Google</p>
                                                                :
                                                                    (campaign.source == 2 ?
                                                                        <p>Facebook</p>
                                                                    :
                                                                        <p>-</p>
                                                                    )
                                                                }

                                                            </td>
                                                            <td>{campaign.accountdata.name}</td>
                                                            <td>{campaign.status === 1 ?
                                                                    <span className="badge badge-pill badge-status bg-success">Active</span>
                                                                :
                                                                    <span className="badge badge-pill badge-status bg-danger">Deactive</span>
                                                                }

                                                            </td>
                                                            <td>
                                                                <Link to={`/admin/campaign-report/${campaign.id}`} className="btn btn-dark btn-sm me-2">
                                                                    <i className="ti ti-bar"></i> Report
                                                                </Link>
                                                                <Link to={`/admin/campaign/${campaign.id}/edit/`} className="btn btn-dark btn-sm me-2">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" className="btn btn-danger btn-sm" onClick={() => showDeletePopup(campaign.id)}>
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="7">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

        <PopupDelete message={delmessage} title={delheading} modalstatus={showModal} btnClickDelete={handleDeleteCampaign} btnClickClose={hideDeletePopup} />

    </div>
    )
}

export default Campaign;